export const config = {
    apiKey: 'AIzaSyCVoTA9OWQcpNYkrgiZukNhh6uIh3l0Zm4'
};

export default  (props) => { return { ...config, ...props }; };


// WEBPACK FOOTER //
// ./src/services/google-maps/config.ts